var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { OmitType, PartialType, PickType } from "@nestjs/swagger";
import { IsBoolean, IsEnum, IsOptional, IsString } from "class-validator";
import { BaseOrganizationDto, BaseOrganizationPublicProfileDto } from "./organization.dtos";
import { UserType } from "./user.dtos";
import { willNeverHappen } from "./utils";
const _INGEST_TYPE_VALUES = ["epic", "bundle", "bulk"];
export const INGEST_TYPE_VALUES = [..._INGEST_TYPE_VALUES];
export function asIngestType(input) {
    if (INGEST_TYPE_VALUES.includes(input)) {
        return input;
    }
    else {
        return null;
    }
}
export var GFIDProvider;
(function (GFIDProvider) {
    GFIDProvider["SMART_ON_FHIR"] = "SMART_ON_FHIR";
    GFIDProvider["CLEAR"] = "CLEAR";
    GFIDProvider["HX_TEST"] = "HX_TEST";
    GFIDProvider["GOOGLE"] = "GOOGLE";
    GFIDProvider["MICROSOFT"] = "MICROSOFT";
    GFIDProvider["APPLE"] = "APPLE";
    GFIDProvider["HOSTED_SSO"] = "HOSTED_SSO";
    GFIDProvider["DEVICE_TOKEN"] = "DEVICE_TOKEN";
})(GFIDProvider || (GFIDProvider = {}));
export function isSocialLoginGfidProvider(gfidProvider) {
    if (gfidProvider === GFIDProvider.GOOGLE ||
        gfidProvider === GFIDProvider.MICROSOFT ||
        gfidProvider === GFIDProvider.APPLE ||
        gfidProvider === GFIDProvider.HOSTED_SSO) {
        return true;
    }
    else if (gfidProvider === GFIDProvider.SMART_ON_FHIR ||
        gfidProvider === GFIDProvider.CLEAR ||
        gfidProvider === GFIDProvider.HX_TEST ||
        gfidProvider === GFIDProvider.DEVICE_TOKEN) {
        return false;
    }
    else {
        willNeverHappen(gfidProvider);
        return false;
    }
}
export function getSocialLoginProviderDisplayName(provider) {
    switch (provider) {
        case GFIDProvider.GOOGLE:
            return "Google";
        case GFIDProvider.MICROSOFT:
            return "Microsoft";
        case GFIDProvider.APPLE:
            return "Apple";
        case GFIDProvider.HOSTED_SSO:
            return "Partner IDP";
        default:
            return "Unknown";
    }
}
export class HealthcareOrganizationPublicProfileDto extends BaseOrganizationPublicProfileDto {
    constructor(fields) {
        super();
        this.type = UserType.HEALTHCARE_ORGANIZATION;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(UserType)
], HealthcareOrganizationPublicProfileDto.prototype, "type", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthcareOrganizationPublicProfileDto.prototype, "patientPortalName", void 0);
__decorate([
    IsBoolean()
], HealthcareOrganizationPublicProfileDto.prototype, "allowDataAccessForPatientIdentification", void 0);
__decorate([
    IsBoolean()
], HealthcareOrganizationPublicProfileDto.prototype, "allowDataAccessForDataDelivery", void 0);
__decorate([
    IsEnum(GFIDProvider, { each: true })
], HealthcareOrganizationPublicProfileDto.prototype, "patientAuthenticationProviders", void 0);
__decorate([
    IsBoolean()
], HealthcareOrganizationPublicProfileDto.prototype, "forcePatientPortalEmbed", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthcareOrganizationPublicProfileDto.prototype, "patientPortalWebLaunchUrl", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthcareOrganizationPublicProfileDto.prototype, "patientPortalMobileAppLaunchUrl", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthcareOrganizationPublicProfileDto.prototype, "patientPortalIosAppInstallUrl", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthcareOrganizationPublicProfileDto.prototype, "patientPortalAndroidAppInstallUrl", void 0);
export class HealthcareOrganizationDto extends BaseOrganizationDto {
    constructor(fields) {
        super();
        this.type = UserType.HEALTHCARE_ORGANIZATION;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(UserType)
], HealthcareOrganizationDto.prototype, "type", void 0);
__decorate([
    IsBoolean()
], HealthcareOrganizationDto.prototype, "allowDataAccessForPatientIdentification", void 0);
__decorate([
    IsBoolean()
], HealthcareOrganizationDto.prototype, "allowDataAccessForDataDelivery", void 0);
__decorate([
    IsString()
], HealthcareOrganizationDto.prototype, "primaryContactName", void 0);
__decorate([
    IsString()
], HealthcareOrganizationDto.prototype, "primaryContactEmail", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthcareOrganizationDto.prototype, "primaryContactPhone", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthcareOrganizationDto.prototype, "patientPortalName", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthcareOrganizationDto.prototype, "patientPortalLink", void 0);
__decorate([
    IsEnum(GFIDProvider, { each: true })
], HealthcareOrganizationDto.prototype, "patientAuthenticationProviders", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], HealthcareOrganizationDto.prototype, "require21CFRPart11ForInformedConsents", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], HealthcareOrganizationDto.prototype, "defaultRequire21CFRPart11ForInformedConsents", void 0);
__decorate([
    IsBoolean()
], HealthcareOrganizationDto.prototype, "forcePatientPortalEmbed", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthcareOrganizationDto.prototype, "patientPortalWebLaunchUrl", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthcareOrganizationDto.prototype, "patientPortalMobileAppLaunchUrl", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthcareOrganizationDto.prototype, "patientPortalIosAppInstallUrl", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthcareOrganizationDto.prototype, "patientPortalAndroidAppInstallUrl", void 0);
export class HealthcareOrganizationPatientFacingDto extends HealthcareOrganizationPublicProfileDto {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], HealthcareOrganizationPatientFacingDto.prototype, "primaryContactName", void 0);
__decorate([
    IsString()
], HealthcareOrganizationPatientFacingDto.prototype, "primaryContactEmail", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthcareOrganizationPatientFacingDto.prototype, "primaryContactPhone", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthcareOrganizationPatientFacingDto.prototype, "patientPortalLink", void 0);
export class CreateHealthcareOrganizationInput extends PickType(HealthcareOrganizationDto, ["name"]) {
    constructor() {
        super(...arguments);
        this.type = UserType.HEALTHCARE_ORGANIZATION;
    }
}
__decorate([
    IsEnum(UserType)
], CreateHealthcareOrganizationInput.prototype, "type", void 0);
export class UpdateHealthcareOrganizationInput extends PartialType(PickType(HealthcareOrganizationDto, ["name"])) {
    constructor() {
        super(...arguments);
        this.type = UserType.HEALTHCARE_ORGANIZATION;
    }
}
__decorate([
    IsEnum(UserType)
], UpdateHealthcareOrganizationInput.prototype, "type", void 0);
export class UpdateHealthcareOrganizationDetailsInput extends PartialType(OmitType(HealthcareOrganizationDto, ["id", "name", "adminEmail"])) {
    constructor(fields) {
        super();
        this.type = UserType.HEALTHCARE_ORGANIZATION;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(UserType)
], UpdateHealthcareOrganizationDetailsInput.prototype, "type", void 0);
